import { render } from "./ConservationArea.vue?vue&type=template&id=37e75d3d&scoped=true&ts=true"
import script from "./ConservationArea.vue?vue&type=script&lang=ts"
export * from "./ConservationArea.vue?vue&type=script&lang=ts"

import "./ConservationArea.vue?vue&type=style&index=0&id=37e75d3d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e75d3d"]])

export default __exports__